import { render, staticRenderFns } from "./InvoiceItemDimensionApprovalsView.vue?vue&type=template&id=46a60d3d&scoped=true&"
import script from "./InvoiceItemDimensionApprovalsView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemDimensionApprovalsView.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemDimensionApprovalsView.vue?vue&type=style&index=0&id=46a60d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a60d3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
